import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from '../../core/layout/layout.component';
import {
  MatTabChangeEvent,
  MatTabGroup,
  MatTabsModule,
} from '@angular/material/tabs';
import { PendingComponent } from './components/pending/pending.component';
import { ApprovedComponent } from './components/approved/approved.component';
import { RejectedComponent } from './components/rejected/rejected.component';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
// import { PermissionDirective } from '../../shared/directives/permissions.directive';
// import { Permission } from '../../shared/services/permissions';
import { AllLeavesComponent } from './components/all-leaves/all-leaves.component';
import { Router } from '@angular/router';
import { PermissionService } from '../../shared/services/permission.service';
import { ModuleIds } from '../../shared/permission-constants/permission-const';

@Component({
  selector: 'app-leave-management',
  standalone: true,
  imports: [
    CommonModule,
    LayoutComponent,
    MatTabGroup,
    MatTabsModule,
    PendingComponent,
    ApprovedComponent,
    RejectedComponent,
    AllLeavesComponent,
    ReactiveFormsModule,
    // PermissionDirective
  ],
  templateUrl: './leave-management.component.html',
  styleUrl: './leave-management.component.scss',
})
export class LeaveManagementComponent {
  @ViewChild('allLeaves') AllLeavesComponent: AllLeavesComponent;
  @ViewChild('pendingLeave') PendingComponent: PendingComponent;
  @ViewChild('approvedLeave') ApprovedComponent: ApprovedComponent;
  @ViewChild('rejectedLeave') RejectedComponent: RejectedComponent;
  searchQuery: string = '';
  isDropdownOpen = false;
  filter: any;
  filterForm: FormGroup;
  activeTabIndex = 0;
  canAddLeave$ = this.permissionService.hasPermission(
    ModuleIds.Leave,
    'Create'
  );
  // Permission = Permission;
  constructor(
    private fb: FormBuilder,
    private route: Router,
    private permissionService: PermissionService
  ) {
    this.filterForm = this.fb.group({
      CL: [false],
      EL: [false],
      EML: [false],
      ML: [false],
      LOP: [false],
    });
  }

  toggleDropdown(event?: MouseEvent) {
    if (event) {
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  onSearch(event: any) {
    this.searchQuery = event.target.value;
  }

  onSubmit() {
    const selectedLeaveTypes = [];
    const formValues = this.filterForm.value;
    for (const leaveType in formValues) {
      if (formValues[leaveType]) {
        selectedLeaveTypes.push(leaveType);
      }
    }
    this.filter = selectedLeaveTypes;
    this.isDropdownOpen = false;
  }

  clearFilter() {
    this.filterForm.reset();
  }

  onTabChange(event: MatTabChangeEvent) {
    console.log(event.index);
    if (event.index === 0) {
      this.activeTabIndex = 0;
      if (this.AllLeavesComponent) {
        this.AllLeavesComponent.fetchAllLeaves();
      }
    } else if (event.index === 1) {
      this.activeTabIndex = 1;
      if (this.PendingComponent) {
        this.PendingComponent.fetchPendingLeaves();
      }
    } else if (event.index === 2) {
      this.activeTabIndex = 2;
      if (this.ApprovedComponent) {
        this.ApprovedComponent.fetchApprovedLeaves();
      }
    } else if (event.index === 3) {
      this.activeTabIndex = 3;
      if (this.RejectedComponent) {
        this.RejectedComponent.fetchRejectedLeaves();
      }
    }
  }

  navigateToApplyLeave() {
    this.route.navigate(['/leaves/apply-leave']);
  }
}
